import { Link as ChakraLink } from '@chakra-ui/react';

import DynamicLink from '@/lib/DynamicLink';

export const A = ChakraLink;

export const Link = props => <DynamicLink Component={A} {...props} />;
